var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.03491V17.4999C22 18.2651 21.7077 19.0014 21.1827 19.5582C20.6578 20.1149 19.9399 20.45 19.176 20.4949L19 20.4999H5C4.23479 20.5 3.49849 20.2076 2.94174 19.6826C2.38499 19.1577 2.04989 18.4398 2.005 17.6759L2 17.4999V8.03491L11.445 14.3319L11.561 14.3979C11.6977 14.4647 11.8478 14.4994 12 14.4994C12.1522 14.4994 12.3023 14.4647 12.439 14.3979L12.555 14.3319L22 8.03491Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.5C20.08 4.5 21.027 5.07 21.555 5.927L12 12.297L2.44501 5.927C2.6958 5.51982 3.0403 5.1785 3.44978 4.93149C3.85926 4.68448 4.32186 4.53894 4.79901 4.507L5.00001 4.5H19Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.2d543aebb25b6ab34e77ec3de9b78181.svg";
export { ForwardRef as ReactComponent };